import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/retail-sales',
};

export const getColumns = () => [
  { id: 'vendor', label: 'Vendor', align: 'center', nameForSort: 'vendor_name' },
  { id: 'itemsSold', label: 'Items Sold', align: 'center', disableSort: true },
  { id: 'turnover', label: 'Turnover', align: 'center', disableSort: true },
  { id: 'costOfSale', label: 'Cost Of Sale', align: 'center', disableSort: true },
  { id: 'region', label: 'Region', align: 'center', nameForSort: 'region' },
  { id: 'coinClaim', label: 'Coin Claim', align: 'center', disableSort: true },
  { id: 'grossIncome', label: 'Gross Income', align: 'center', disableSort: true },
  {
    id: 'salesPercent',
    label: 'Sales %',
    align: 'center',
    disableSort: true,
  },
  {
    id: 'coinClaimPercent',
    label: 'CC %',
    align: 'center',
    disableSort: true,
  },
  {
    id: 'grossOnIncomePercent',
    label: 'GI %',
    align: 'center',
    disableSort: true,
  },
  {
    id: 'grossOnRevenuePercent',
    label: 'GR %',
    align: 'center',
    disableSort: true,
  },
];

export const getFilters = ({ dateRange, region, options }) => [
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'regions',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
